import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

import Gallery from './Gallery'

const images = [
  "BPF_FLYER_01",
  "DI_1",
  "EXHIBITION",
  "HOWDO_12",
  "LEBANESE_ARCHIVE_7",
  "LEBANESE_ARCHIVE_18_SMALL",
  "LEBANESE_ARCHIVE_21",
  "LIZ-ORTON_2",
  "P1020061_RT_test",
  "P1020071_RT",
  "STORY_FEST_3",
  "STORY_FEST_11",
  "WEBSITE_IMAGE_LAND_GATHERING_03",
  "WEBSITE_IMAGE_LAND_MAO_01",
]

class App extends Component {
  render() {
    return (
      <div className="Template">
        <header>
          <h1>Kelly Barrow &ndash; Graphic Designer</h1>
        </header>
          <Gallery slides={images}/>
        <footer>
          <p><a href="mailto:hello@kellybarrow.co.uk">Email</a></p>
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js